import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import { imgEllipse921 } from './assets'
import { selectPersonalizedRoles } from '../../../../redux/userInfoSlice'
import { useSelector } from 'react-redux'
import { selectSkillName } from '../../../../redux/skillSlice'

const OutcomeSection = ({ skillName }) => {
  // Simplified job roles array


  const personalizedRoles = useSelector(selectPersonalizedRoles);
 

  return (
    <div className="w-full content-stretch flex flex-col gap-[24px] items-start relative shrink-0 w-full">
      <div className="content-stretch flex items-center relative shrink-0 w-full">
        <div className="flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[#70aeff] text-[18px] whitespace-nowrap">
          <p className="leading-none">Your Outcome In 4 Weeks</p>
        </div>
      </div>
      
      <div className="w-full flex flex-col gap-[16px] items-start relative shrink-0">
        {/* Roles Section */}
        <div className="w-full bg-gradient-to-l flex flex-col from-[rgba(64,106,255,0)] items-start overflow-hidden p-[12px] relative rounded-[16px] shrink-0 to-[rgba(64,106,255,0.2)] w-full">
          <div className="w-full flex flex-col gap-[16px] items-start justify-center relative shrink-0 w-full">
            <div className="w-fullcapitalize flex flex-col font-normal justify-center leading-[0] text-[14px] text-[rgba(255,255,255,0.5)] tracking-[0.14px]">
              <p className="leading-[1.3]">Roles You Can Apply To</p>
            </div>
            <div className="w-full overflow-hidden">
              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={8}
                slidesPerView={1.5}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                loop={true}
                speed={1000}
                className="w-full !overflow-visible"
              >
                {personalizedRoles?.map((role, index) => (
                  <SwiperSlide key={`${index}`}>
                    <div className='flex flex-row gap-2 items-center'>
                      <div className="bg-gradient-to-b w-full flex from-[rgba(64,106,255,0.5)] items-center justify-center p-[12px] rounded-[8px] to-[rgba(7,33,64,0.5)]">
                        <p className="text-center font-medium leading-none not-italic text-[14px] text-white">
                          {role?.title}
                        </p>
                      </div>
                      <div className="w-1 h-1 rounded-full bg-[#70AEFF]/35"/>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        
        {/* Salary Range Section */}
        <div className="w-full bg-gradient-to-l content-stretch flex flex-col from-[rgba(64,106,255,0)] items-start overflow-clip p-[12px] relative rounded-[16px] shrink-0 to-[rgba(64,106,255,0.2)] w-[358px]">
          <div className="w-full flex flex-col gap-[16px] items-start justify-center leading-[0] relative shrink-0 w-[304px]">
            <div className="capitalize flex flex-col font-['Inter:Regular',sans-serif] font-normal justify-center min-w-full not-italic relative shrink-0 text-[14px] text-[rgba(255,255,255,0.5)] tracking-[0.14px] w-[min-content]">
              <p className="leading-none">Expected Salary Range</p>
            </div>
            <div className="w-full  flex flex-col gap-[12px] items-start relative shrink-0 text-center">
              <div className="content-stretch flex gap-[4px] items-end not-italic relative shrink-0">
                <div className="flex flex-col font-bold justify-center relative shrink-0 text-[28px] text-white ">
                  <p className="leading-none">₹8L - ₹34L</p>
                </div>
                <div className="flex flex-col font-['Inter:Regular',sans-serif] font-normal h-[22px] justify-center relative shrink-0 text-[16px] text-[rgba(255,255,255,0.3)] w-[21px]">
                  <p className="leading-none">/yr</p>
                </div>
              </div>
              <div className="flex flex-col font-light italic justify-center relative shrink-0 text-[12px] text-[rgba(255,255,255,0.7)] text-left">
                <p className="leading-none">Based on {skillName} roles in India (2023–25 industry data)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OutcomeSection